export enum PostMessageEvent {
  ON_TUTOR_LOAD = 'onTutorLoad',
  ON_TOKEN_RECEIVED = 'authTokenReceived',
  SHOW_PIN_WINDOW = 'showPinWindow',
  CLOSE_PIN_WINDOW = 'closePinWindow',
}

export enum PostMessageTypes {
  AUTH_TOKEN = 'authToken',
  MINIMIZE = 'minimize'
}

export type PostMessageEventType = {
  data: {
    type: string;
    authToken: string;
  };
};
